module.exports = __webpack_public_path__ + "static/media/store.eb0f097e.svg";